module.exports = __webpack_public_path__ + "static/media/Whimsicott_gaussian2.4ac606a7.png";